import { render, staticRenderFns } from "./fileadministrationTable.vue?vue&type=template&id=58816810&scoped=true&"
import script from "./fileadministrationTable.vue?vue&type=script&lang=js&"
export * from "./fileadministrationTable.vue?vue&type=script&lang=js&"
import style0 from "./fileadministrationTable.vue?vue&type=style&index=0&id=58816810&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58816810",
  null
  
)

export default component.exports